function onlyDigits (value) {
  let result = '';
  for (let i = 0; i < value.length; i++) {
    const ch = value[i];
    if (ch >= '0' && ch <= '9') {
      result += ch;
    }
  }
  return result;
}

export const Cpf = value => {
  const digits = onlyDigits(value).slice(0, 11);
  let result = '';
  for (let i = 0; i < digits.length; i++) {
    if (i === 3 || i === 6) result += '.';
    if (i === 9) result += '-';
    result += digits[i];
  }
  return result;
};

export const Phone = value => {
  const digits = onlyDigits(value).slice(0, 11);
  if (digits.length <= 2) return digits;
  let result = '(' + digits[0] + digits[1] + ')';
  for (let i = 2; i < digits.length; i++) {
    if (i === 7) result += '-';
    result += digits[i];
  }
  return result;
};

export const DateM = value => {
  const digits = onlyDigits(value).slice(0, 8);
  let result = '';
  for (let i = 0; i < digits.length; i++) {
    if (i === 2 || i === 4) result += '/';
    result += digits[i];
  }
  return result;
};

export const expDate = value => {
  const digits = onlyDigits(value);
  let result = '';
  for (let i = 0; i < digits.length; i++) {
    if (i === 2) result += '/';
    result += digits[i];
  }
  return result;
};

export const Hour = value => {
  const digits = onlyDigits(value);
  let result = '';
  for (let i = 0; i < digits.length; i++) {
    if (i === 2) result += ':';
    result += digits[i];
  }
  return result;
};

export const CEP = value => {
  const digits = onlyDigits(value).slice(0, 8);
  let result = '';
  for (let i = 0; i < digits.length; i++) {
    if (i === 4) result += '-';
    result += digits[i];
  }
  return result;
};
